import {useEffect} from "react";
import {useLocation} from "react-router-dom";
import PropTypes from "prop-types";
import SoftBox from "../../../components/SoftBox";
import {setLayout, useRayzayUIController} from "../../../context";
import Header from "../../Header";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Footer from "../../Footer";

function DashboardLayout({ children }) {
    const [controller, dispatch] = useRayzayUIController();
  const { miniSidenav } = controller;
  const { pathname } = useLocation();

  useEffect(() => {
    setLayout(dispatch, "dashboard");
  }, [dispatch, pathname]);

  return (
    <SoftBox
      sx={({ breakpoints, transitions, functions: { pxToRem } }) => ({
        p: 3,
        position: "relative",
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
          width: "calc(100% - ${miniSidenav ? pxToRem(120) : pxToRem(274)})",
        [breakpoints.up("xl")]: {
          marginLeft: miniSidenav ? pxToRem(120) : pxToRem(274),
            transition: transitions.create(["margin-left", "margin-right", "width"], {
            easing: transitions.easing.easeInOut,
            duration: transitions.duration.standard,
          }),
        },
      })}
    >
        <Header/>
        <SoftBox mt={5} mb={3} flexGrow={1}>
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <Card>
                        {children}
                    </Card>
                </Grid>
            </Grid>
        </SoftBox>
        <Footer/>
    </SoftBox>
  );
}

DashboardLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default DashboardLayout;
